<template>
  <div v-if="comboCompany" class="combo-widget">
    <ComboProgress />
  </div>

  <TheModal v-if="comboCompany"  v-model:show="showModal">
    <div class="stop__body modal__body center">
      <div class="modal__close center" @click="showModal = false"><svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                                                       xmlns="http://www.w3.org/2000/svg">
        <path d="M5.33333 5.33398L26.6667 26.6673M26.6667 5.33398L5.33333 26.6673" stroke="white" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      </div>
      <div class="stop__body-img" v-html="comboCompany.modal_icon"></div>
      <div class="stop__body-title">ура! ты прошел квест! держи подарок</div>
      <div class="stop__body-text"> {{comboCompany.description}}</div>
      <div  class="stop__body-btn"><a class="btn close__modal"  style="background: rgba(30, 147, 230, 1)" @click="showModal = false">Классно</a></div>
    </div>
  </TheModal>
</template>

<script>
import { mapState } from "vuex";
import TheModal from "@/components/TheModal.vue";
import ComboProgress from '@/components/element/ComboProgress.vue';

export default {
  name: "ComboWidget",
  components: {
    TheModal,
    ComboProgress
},
  computed: {
    ...mapState({
      comboCompany: (state) => state.cart.comboCompany,
      comboCompanyModalIsShow: (state) => state.cart.comboCompanyModalIsShow,
    }),
  },
  data(){
    return {
      showModal: false
    }
  },
  watch:{
    'comboCompany.progress.complete'(value) {
      this.showModal = value;
    }
  }
}
</script>
